import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { Spinner } from './Spinner.js';
import styles from './Button.module.css';

/**
 * `inverse`는 **어두운 면 위**에 얹는 버튼이다(저장 바 등). 팔레트가 무채색이라
 * 기본 버튼은 잉크색인데, 잉크색 배경 위에 두면 배경과 같은 색이 되어 사라진다.
 */
type Variant = 'solid' | 'outline' | 'inverse' | 'quiet' | 'danger';
type Size = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  /** 진행 중에는 비활성화하고 스피너를 보여준다 */
  loading?: boolean;
  children: ReactNode;
}

export function Button({
  variant = 'solid',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled,
  children,
  className,
  ...rest
}: ButtonProps) {
  const classes = [
    styles.base,
    styles[variant],
    styles[size],
    fullWidth ? styles.full : '',
    loading ? styles.relative : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      disabled={disabled === true || loading}
      // 진행 중임을 스크린 리더에도 알린다
      aria-busy={loading || undefined}
      {...rest}
    >
      <span className={loading ? styles.loadingLabel : undefined}>{children}</span>
      {loading ? (
        <span className={styles.spinnerSlot}>
          <Spinner size={16} />
        </span>
      ) : null}
    </button>
  );
}
